
export default {
  name: "ParentCompanyDetails",
  data() {
    return {
      parentCompanyName: "",
      parentCompanyLocation: "",
      valid: false,
      hasLocationSelectorError: false
    };
  },
  computed: {
    isFormValid() {
      return this.valid && this.parentCompanyLocation;
    }
  },
  methods: {
    getAddressData(locationData) {
      this.hasLocationSelectorError = false;
      this.parentCompanyLocation = locationData.formatted_address;
    },
    handleLocationError(e) {
      if (!this.parentCompanyLocation) {
        e.target.value = "";
        this.hasLocationSelectorError = true;
      } else {
        this.hasLocationSelectorError = false;
      }
    },
    validateForm() {
      this.valid = this.$refs.parentCompanyForm.validate();
    },

    submitParentCompanyDetails() {
      this.validateForm();
      if (this.isFormValid) {
        const data = {
          parentCompanyName: this.parentCompanyName,
          parentCompanyLocation: this.parentCompanyLocation
        };
        this.$emit("submit-parent", data);
      }
    }
  }
};
